module.exports = __webpack_public_path__ + "static/img/performanceplanner.d96f5bff.png";